import type { ComputedRef, MaybeRefOrGetter, Ref } from 'vue'
import type { AutologinFormData } from '@ts-student-app/interfaces'

import { useCustomerStore } from '@stores/me/customer'

import { getStudentAppAutologin } from '@utils/student-app/autologin'
import amplitudeConfig from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

interface LinkStudentAppOptions {
  redirect?: MaybeRefOrGetter<string | null>
}

interface LinkStudentAppReturn {
  text: string
  formRef: Ref<HTMLFormElement | null>
  formData: ComputedRef<AutologinFormData | null>
  handleClick: () => void
}

export const useLinkStudentApp = (options: LinkStudentAppOptions = {}): LinkStudentAppReturn => {
  const customerStore = useCustomerStore()
  const route = useRoute()

  const text = 'Practice'

  const formRef = ref<HTMLFormElement | null>(null)

  // POST the signature to avoid flagging Student app as Dangerous on some browsers (e.g. Chrome).
  const formData = computed<AutologinFormData | null>(() => getStudentAppAutologin(toValue(options.redirect) ?? null))

  const handleClick = (): void => {
    trackEvent(amplitudeConfig.events.clickButton, {
      button_name: 'link_student_app',
      text,
      cs_page: route.path,
      kids_count: customerStore.getKids.length,
    })

    // The DS MenuButton is a type="button" button: submit the form once the click is tracked.
    formRef.value?.submit()
  }

  return {
    text,
    formRef,
    formData,
    handleClick,
  }
}
